module.exports = __webpack_public_path__ + "img/Group Roster.6da1fbc5.svg";